import { useState } from 'react'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import ActionModal from '../ActionModal'
import classes from './index.module.css'

const BlockStudentModal = ({ title, content, onConfirm, onDismiss, checkboxLabel = 'Удалить курсы учащегося' }) => {
  const [removeCourses, setRemoveCourses] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const confirm = async () => {
    if (isSubmitting) return
    setIsSubmitting(true)
    try {
      await onConfirm(removeCourses)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <ActionModal
      title={title}
      content={content}
      onAction={confirm}
      onDismiss={isSubmitting ? () => {} : onDismiss}
      isSubmitting={isSubmitting}
    >
      <CheckboxViolet
        text={checkboxLabel}
        value={removeCourses}
        onClick={() => !isSubmitting && setRemoveCourses((value) => !value)}
        className={classes.checkbox}
      />
    </ActionModal>
  )
}

export default BlockStudentModal
